<template>
<div class="chapter">
<div class="inner_page">
<div class="coverpage">
<img alt="i_Image2" src="images/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780891128793_Part01.vue?36550e5d